var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcs1Plug(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 89,
    viewBox: "0 0 64 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_19827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.997 47.897C44.7238 47.897 55.0408 37.4419 55.0408 24.545C55.0408 11.648 44.7238 1.19299 31.997 1.19299C19.2703 1.19299 8.95325 11.648 8.95325 24.545C8.95325 37.4419 19.2703 47.897 31.997 47.897Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.997 17.7809C22.155 17.7809 13.7528 24.0379 10.4524 32.8419C13.7528 41.6458 22.1491 47.9029 31.997 47.9029C41.845 47.9029 50.2413 41.6458 53.5417 32.8419C50.2413 24.0379 41.845 17.7809 31.997 17.7809Z",
    fill: "#31404C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7261 30.6887C45.7261 32.6213 44.1678 34.19 42.2479 34.19C40.3281 34.19 38.7697 32.6213 38.7697 30.6887C38.7697 28.7561 40.3281 27.1874 42.2479 27.1874C44.1678 27.1874 45.7261 28.7561 45.7261 30.6887Z",
    fill: "#0D1316"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9507 37.0947C36.9507 39.8385 34.7405 42.0634 32.0148 42.0634C29.2891 42.0634 27.079 39.8385 27.079 37.0947C27.079 34.3509 29.2891 32.1261 32.0148 32.1261C34.7405 32.1261 36.9507 34.3509 36.9507 37.0947Z",
    fill: "#0D1316"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.8032 29.4182C45.8032 31.3746 44.227 32.9612 42.2835 32.9612C40.34 32.9612 38.7638 31.3746 38.7638 29.4182C38.7638 27.4617 40.34 25.8751 42.2835 25.8751C44.227 25.8751 45.8032 27.4617 45.8032 29.4182Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6091 17.8823C29.6091 20.7931 27.2627 23.1552 24.3711 23.1552C21.4795 23.1552 19.133 20.7931 19.133 17.8823C19.133 14.9715 21.4795 12.6095 24.3711 12.6095C27.2627 12.6095 29.6091 14.9715 29.6091 17.8823Z",
    fill: "#0D1316"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9873 30.6887C24.9873 32.6213 23.4289 34.19 21.5091 34.19C19.5893 34.19 18.0309 32.6213 18.0309 30.6887C18.0309 28.7561 19.5893 27.1874 21.5091 27.1874C23.4289 27.1874 24.9873 28.7561 24.9873 30.6887Z",
    fill: "#0D1316"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7771 23.5548C42.6699 23.5548 45.0151 21.1941 45.0151 18.282C45.0151 15.3699 42.6699 13.0092 39.7771 13.0092C36.8842 13.0092 34.539 15.3699 34.539 18.282C34.539 21.1941 36.8842 23.5548 39.7771 23.5548Z",
    fill: "#0D1316"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2511 29.5255C40.1918 28.2968 41.134 27.247 42.3546 27.1874C43.5752 27.1277 44.6181 28.0761 44.6774 29.3048C44.7366 30.5336 43.7945 31.5834 42.5738 31.643C41.3532 31.7027 40.3103 30.7543 40.2511 29.5255Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.7014 29.5016C40.654 28.5234 41.4006 27.6883 42.3724 27.6406C43.3441 27.5929 44.1737 28.3444 44.2211 29.3226C44.2685 30.3009 43.5219 31.1359 42.5501 31.1836C41.5784 31.2314 40.7488 30.4798 40.7014 29.5016Z",
    fill: "url(#paint0_linear_6_19827)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0643 29.4182C25.0643 31.3746 23.4882 32.9612 21.5447 32.9612C19.6011 32.9612 18.025 31.3746 18.025 29.4182C18.025 27.4617 19.6011 25.8751 21.5447 25.8751C23.4882 25.8751 25.0643 27.4617 25.0643 29.4182Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5123 29.5255C19.453 28.2968 20.3952 27.247 21.6158 27.1874C22.8364 27.1277 23.8793 28.0761 23.9385 29.3048C23.9978 30.5336 23.0556 31.5834 21.835 31.643C20.6144 31.7027 19.5715 30.7543 19.5123 29.5255Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.0278 29.5016C19.9804 28.5592 20.7033 27.7539 21.6395 27.7062C22.5757 27.6585 23.3756 28.3862 23.423 29.3286C23.4704 30.271 22.7475 31.0763 21.8113 31.124C20.8751 31.1717 20.0752 30.444 20.0278 29.5016Z",
    fill: "url(#paint1_linear_6_19827)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9329 35.544C36.9329 38.2579 34.7464 40.4589 32.0504 40.4589C29.3543 40.4589 27.1679 38.2579 27.1679 35.544C27.1679 32.83 29.3543 30.629 32.0504 30.629C34.7464 30.629 36.9329 32.83 36.9329 35.544Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1183 35.544C34.1183 36.6952 33.194 37.6257 32.0504 37.6257C30.9068 37.6257 29.9824 36.6952 29.9824 35.544C29.9824 34.3928 30.9068 33.4623 32.0504 33.4623C33.194 33.4623 34.1183 34.3928 34.1183 35.544Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.6091 16.9398C29.6091 19.8506 27.2627 22.2127 24.3711 22.2127C21.4795 22.2127 19.133 19.8506 19.133 16.9398C19.133 14.029 21.4795 11.667 24.3711 11.667C27.2627 11.667 29.6091 14.029 29.6091 16.9398Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.27 16.9399C28.27 19.1111 26.522 20.8647 24.3711 20.8647C22.2202 20.8647 20.4722 19.1051 20.4722 16.9399C20.4722 14.7747 22.2202 13.0151 24.3711 13.0151C26.522 13.0151 28.27 14.7747 28.27 16.9399Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.7426 16.9398C27.7426 18.8128 26.2316 20.3338 24.3711 20.3338C22.5105 20.3338 20.9995 18.8128 20.9995 16.9398C20.9995 15.0669 22.5105 13.5459 24.3711 13.5459C26.2316 13.5459 27.7426 15.0669 27.7426 16.9398Z",
    fill: "url(#paint2_linear_6_19827)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0921 16.9399C45.0921 19.8924 42.7101 22.2902 39.7771 22.2902C36.844 22.2902 34.462 19.8924 34.462 16.9399C34.462 13.9873 36.844 11.5895 39.7771 11.5895C42.7101 11.5895 45.0921 13.9873 45.0921 16.9399Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.271 35.5439C33.271 36.2239 32.7259 36.7727 32.0504 36.7727C31.3749 36.7727 30.8297 36.2239 30.8297 35.5439C30.8297 34.8639 31.3749 34.3152 32.0504 34.3152C32.7259 34.3152 33.271 34.8639 33.271 35.5439Z",
    fill: "url(#paint3_linear_6_19827)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0165 89H17.9776C8.04666 89 0 80.8939 0 70.903C0 60.906 8.05259 52.8059 17.9776 52.8059H46.0165C55.9474 52.8059 63.9941 60.912 63.9941 70.903C63.9941 80.8999 55.9415 89 46.0165 89Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8209 85.3794H18.1791C10.2331 85.3794 3.79224 78.8957 3.79224 70.897C3.79224 62.8982 10.2331 56.4146 18.1791 56.4146H45.8209C53.7669 56.4146 60.2078 62.8982 60.2078 70.897C60.2078 78.8957 53.7669 85.3794 45.8209 85.3794Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8209 85.3794H18.1791C10.2331 85.3794 3.79224 78.8957 3.79224 70.897C3.79224 62.8982 10.2331 56.4146 18.1791 56.4146H45.8209C53.7669 56.4146 60.2078 62.8982 60.2078 70.897C60.2078 78.8957 53.7669 85.3794 45.8209 85.3794Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6709 64.98C11.9159 64.98 6.25127 69.6683 4.70475 75.9849C6.74901 81.4725 12.0107 85.3794 18.1731 85.3794H45.815C52.5699 85.3794 58.2346 80.6911 59.7811 74.3745C57.7369 68.8869 52.4751 64.98 46.3127 64.98H18.6709Z",
    fill: "#31404C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2078 70.903C60.3203 77.3031 56.2437 82.9637 50.2176 84.9619C47.6756 85.8924 43.7885 85.6538 41.1043 85.6896C34.0472 85.6896 24.217 85.785 17.1895 85.624C11.7796 85.2959 6.78455 81.5918 4.80548 76.5277C4.12999 74.7502 3.76261 72.8057 3.79224 70.903C3.85742 72.7997 4.2722 74.6965 5.00102 76.4442C7.34747 81.7707 12.5499 85.1647 18.345 85.0931C24.8747 85.0692 34.5449 85.0334 41.1043 85.0812C43.7174 85.0633 47.563 85.3138 50.0635 84.4728C55.9889 82.6356 60.0537 77.1361 60.2078 70.903Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3213 84.5861C24.3067 84.5861 29.1588 79.7018 29.1588 73.6766C29.1588 67.6514 24.3067 62.7671 18.3213 62.7671C12.3359 62.7671 7.48375 67.6514 7.48375 73.6766C7.48375 79.7018 12.3359 84.5861 18.3213 84.5861Z",
    fill: "#0D1316"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0179 84.3594C53.0033 84.3594 57.8554 79.4751 57.8554 73.4499C57.8554 67.4248 53.0033 62.5404 47.0179 62.5404C41.0325 62.5404 36.1804 67.4248 36.1804 73.4499C36.1804 79.4751 41.0325 84.3594 47.0179 84.3594Z",
    fill: "#0D1316"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.0368 82.3254C24.0222 82.3254 28.8744 77.441 28.8744 71.4159C28.8744 65.3907 24.0222 60.5063 18.0368 60.5063C12.0515 60.5063 7.19933 65.3907 7.19933 71.4159C7.19933 77.441 12.0515 82.3254 18.0368 82.3254Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0368 82.3254C24.0222 82.3254 28.8744 77.441 28.8744 71.4159C28.8744 65.3907 24.0222 60.5063 18.0368 60.5063C12.0515 60.5063 7.19933 65.3907 7.19933 71.4159C7.19933 77.441 12.0515 82.3254 18.0368 82.3254Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0368 60.5005C12.0522 60.5005 7.19933 65.3856 7.19933 71.41C7.19933 77.4344 12.0522 82.3195 18.0368 82.3195C24.0215 82.3195 28.8744 77.4344 28.8744 71.41C28.8744 65.3856 24.0215 60.5005 18.0368 60.5005ZM18.0368 81.1504C12.6981 81.1504 8.36663 76.7902 8.36663 71.416C8.36663 66.0417 12.6981 61.6815 18.0368 61.6815C23.3756 61.6815 27.7071 66.0417 27.7071 71.416C27.7071 76.7902 23.3756 81.1504 18.0368 81.1504Z",
    fill: "#6396A8"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47329 69.9724C9.42135 62.3077 18.6057 58.8542 24.3711 63.8944C26.1191 65.4094 27.2982 67.5746 27.5886 69.871C27.1738 67.6104 25.9591 65.5227 24.2111 64.0793C18.4931 59.2717 9.72947 62.6 8.46736 69.9724H8.47329Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.0179 82.3254C53.0033 82.3254 57.8554 77.441 57.8554 71.4159C57.8554 65.3907 53.0033 60.5063 47.0179 60.5063C41.0325 60.5063 36.1804 65.3907 36.1804 71.4159C36.1804 77.441 41.0325 82.3254 47.0179 82.3254Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0179 60.5005C41.0332 60.5005 36.1804 65.3856 36.1804 71.41C36.1804 77.4344 41.0332 82.3195 47.0179 82.3195C53.0025 82.3195 57.8554 77.4344 57.8554 71.41C57.8554 65.3856 53.0025 60.5005 47.0179 60.5005ZM47.0179 81.0371C41.7384 81.0371 37.4602 76.7306 37.4602 71.416C37.4602 66.1014 41.7384 61.7948 47.0179 61.7948C52.2974 61.7948 56.5755 66.1014 56.5755 71.416C56.5755 76.7306 52.2974 81.0371 47.0179 81.0371Z",
    fill: "#6396A8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.5342 71.4159C22.5342 73.9152 20.5196 75.9372 18.0428 75.9372C15.566 75.9372 13.5513 73.9092 13.5513 71.4159C13.5513 68.9227 15.566 66.8947 18.0428 66.8947C20.5196 66.8947 22.5342 68.9227 22.5342 71.4159Z",
    fill: "url(#paint4_linear_6_19827)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5342 71.4159C22.6705 73.8913 20.49 76.0923 18.0428 76.0505C15.5956 76.0923 13.4091 73.8913 13.5513 71.4159C13.5928 73.8078 15.6726 75.8775 18.0428 75.8298C20.4129 75.8835 22.4927 73.8078 22.5342 71.4159Z",
    fill: "#6396A8"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1686 16.3016C19.6071 12.1561 24.7325 10.3011 27.8196 12.9972C28.7677 13.8084 29.4373 14.9775 29.5617 16.2241C29.3069 15.0132 28.6196 13.9277 27.6715 13.1821C24.6377 10.7186 19.927 12.4424 19.1745 16.3016H19.1686Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.264 17.1248C28.3826 19.2542 26.445 21.0913 24.3651 21.0675C22.2794 21.0973 20.3477 19.2542 20.4663 17.1248C20.5255 19.1707 22.3564 20.8825 24.3651 20.8468C26.3739 20.8825 28.2048 19.1707 28.264 17.1248Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.239 34.8699C27.6715 31.0703 32.394 29.3584 35.2323 31.8279C36.1152 32.5734 36.7314 33.6471 36.8618 34.7983C36.6425 33.671 36.0026 32.6569 35.1256 31.965C32.3111 29.6567 27.9026 31.2731 27.2449 34.8699H27.239Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1183 35.6692C34.1716 37.9358 30.9779 38.5084 30.1068 36.4565C30.0061 36.206 29.9587 35.9316 29.9824 35.6692C30.0239 36.2001 30.2965 36.6713 30.6757 36.9993C31.8548 38.0968 33.988 37.3095 34.1124 35.6692H34.1183Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8053 28.8992C39.1371 26.2031 42.5798 24.9625 44.5825 26.7817C45.2166 27.3185 45.6847 28.0761 45.7676 28.8992C45.5899 28.094 45.104 27.4021 44.4759 26.9129C42.5205 25.2547 39.3504 26.4119 38.8053 28.8992Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6477 29.782C44.5588 30.8556 43.4923 31.6728 42.4553 31.7026C41.3947 31.7026 40.3755 30.8497 40.2748 29.782C40.4466 30.8258 41.4362 31.6191 42.4553 31.6132C43.4626 31.5893 44.4937 30.8139 44.6477 29.782Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0665 28.8217C18.3983 26.1256 21.8409 24.885 23.8437 26.7042C24.4777 27.241 24.9458 27.9986 25.0288 28.8217C24.851 28.0165 24.3652 27.3245 23.7371 26.8354C21.7817 25.1772 18.6116 26.3344 18.0665 28.8217Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9089 29.77C23.82 30.8437 22.7534 31.6608 21.7165 31.6907C20.6559 31.6907 19.6367 30.8377 19.536 29.77C19.7078 30.8139 20.6973 31.6131 21.7165 31.6012C22.7238 31.5773 23.7548 30.8019 23.9089 29.77Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5805 16.1883C35.019 12.0428 40.1444 10.1878 43.2316 12.8839C44.1796 13.6951 44.8492 14.8642 44.9736 16.1108C44.7188 14.9 44.0315 13.8144 43.0834 13.0688C40.0496 10.6053 35.339 12.3292 34.5864 16.1883H34.5805Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.676 17.0115C43.7945 19.1409 41.8569 20.978 39.7771 20.9542C37.6913 20.984 35.7596 19.1409 35.8782 17.0115C35.9374 19.0574 37.7683 20.7693 39.7771 20.7335C41.7858 20.7693 43.6167 19.0574 43.676 17.0115Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.0179 75.9372C49.4984 75.9372 51.5093 73.913 51.5093 71.4159C51.5093 68.9189 49.4984 66.8947 47.0179 66.8947C44.5373 66.8947 42.5264 68.9189 42.5264 71.4159C42.5264 73.913 44.5373 75.9372 47.0179 75.9372Z",
    fill: "url(#paint5_linear_6_19827)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.349 47.3839H26.6346V54.6251H38.349V47.3839Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.676 16.9399C43.676 19.1111 41.928 20.8647 39.7771 20.8647C37.6261 20.8647 35.8782 19.1051 35.8782 16.9399C35.8782 14.7747 37.6261 13.0151 39.7771 13.0151C41.928 13.0151 43.676 14.7747 43.676 16.9399Z",
    fill: "#1E272D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.0504 0.041748C18.6057 0.041748 7.70299 11.0109 7.70299 24.5449C7.70299 38.0789 18.5998 49.0541 32.0504 49.0541C45.501 49.0541 56.3977 38.0849 56.3977 24.5449C56.3977 11.005 45.495 0.041748 32.0504 0.041748ZM32.0504 44.6044C21.0647 44.6044 12.1233 35.6036 12.1233 24.5449C12.1233 13.4863 21.0647 4.48549 32.0504 4.48549C43.036 4.48549 51.9774 13.4863 51.9774 24.5449C51.9774 35.6036 43.036 44.6044 32.0504 44.6044Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3918 24.545C56.2022 7.47984 38.6512 -4.19914 22.9786 2.19507C14.1083 5.67848 7.8926 14.733 7.87482 24.3601C7.58448 10.9275 18.9079 -0.172936 32.1689 4.1547e-05C45.3351 -0.0596059 56.6881 11.2257 56.3918 24.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9715 24.6762C52.2322 35.6811 42.8286 44.7416 32.003 44.6461C21.2069 44.7118 11.8448 35.4843 12.1174 24.5509C12.1766 32.4363 17.2902 39.7908 24.5074 42.7136C37.241 48.0341 51.7937 38.6516 51.9715 24.6821V24.6762Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.0504 45.3798C20.6381 45.3798 11.353 36.0331 11.353 24.5449C11.353 13.0568 20.6381 3.71008 32.0504 3.71008C43.4626 3.71008 52.7477 13.0568 52.7477 24.5449C52.7477 36.0331 43.4626 45.3798 32.0504 45.3798ZM32.0504 4.27673C20.9462 4.27673 11.9159 13.367 11.9159 24.5449C11.9159 35.7229 20.9462 44.8132 32.0504 44.8132C43.1545 44.8132 52.1848 35.7229 52.1848 24.5449C52.1848 13.367 43.1486 4.27673 32.0504 4.27673Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1486 16.9398C43.1486 18.8128 41.6376 20.3338 39.7771 20.3338C37.9165 20.3338 36.4055 18.8128 36.4055 16.9398C36.4055 15.0669 37.9165 13.5459 39.7771 13.5459C41.6376 13.5459 43.1486 15.0669 43.1486 16.9398Z",
    fill: "url(#paint6_linear_6_19827)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4543 70.2707C38.4024 62.606 47.5867 59.1524 53.3521 64.1926C55.1001 65.7076 56.2792 67.8728 56.5696 70.1693C56.1548 67.9086 54.9401 65.821 53.1921 64.3775C47.4741 59.5699 38.7105 62.8982 37.4484 70.2707H37.4543Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5093 71.4159C51.6456 73.8913 49.465 76.0923 47.0179 76.0505C44.5707 76.0923 42.3842 73.8913 42.5264 71.4159C42.5679 73.8078 44.6477 75.8775 47.0179 75.8298C49.388 75.8835 51.4678 73.8078 51.5093 71.4159Z",
    fill: "#6396A8"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0236997 70.5511C-0.402927 60.8226 8.15332 52.9551 17.545 52.7284C20.6025 52.7284 23.6363 52.794 26.682 52.8835C25.1591 52.9312 23.6363 52.9551 22.1135 52.9908L19.8322 53.0207C9.64651 52.5435 0.231088 59.9398 0.0236997 70.5511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2957 52.8834C40.9384 52.794 43.5752 52.7403 46.2179 52.7164C47.5511 52.7164 48.8844 52.8775 50.182 53.1817C55.3963 54.3448 60.03 57.9833 62.2816 62.8744C62.8386 64.0852 63.2534 65.3677 63.5023 66.6739C63.1527 65.3915 62.7023 64.1389 62.0861 62.9758C59.1116 57.0707 52.7655 53.1996 46.212 53.0684C43.5752 53.0147 40.9325 52.9908 38.2957 52.8894V52.8834Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_19827",
    x1: 42.4613,
    y1: 27.6406,
    x2: 42.4613,
    y2: 31.1896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_19827",
    x1: 21.7224,
    y1: 27.7062,
    x2: 21.7224,
    y2: 31.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_19827",
    x1: 24.3711,
    y1: 13.5399,
    x2: 24.3711,
    y2: 20.3338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_19827",
    x1: 32.0504,
    y1: 34.3152,
    x2: 32.0504,
    y2: 36.7727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_19827",
    x1: 18.0368,
    y1: 75.9372,
    x2: 18.0368,
    y2: 66.8887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_19827",
    x1: 47.0179,
    y1: 0.0000293586,
    x2: 47.0179,
    y2: 0.0000293586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_19827",
    x1: 39.7771,
    y1: 13.5399,
    x2: 39.7771,
    y2: 20.3338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_19827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 89,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcs1Plug);
export default __webpack_public_path__ + "static/media/ccs1_plug.eafbc38e1504ff8fd93ba38baf2a5f7f.svg";
export { ForwardRef as ReactComponent };